"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NewTableStyledTbody = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _mixins = require("../../styles/mixins");
var HBNewTableNoResults = function HBNewTableNoResults(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    columnsCount = _ref.columnsCount;
  return /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: columnsCount
  }, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body18"
  }, title), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textTertiary"
  }, subtitle)))));
};
var _default = exports["default"] = HBNewTableNoResults; // --- Styles ---
var NewTableStyledTbody = exports.NewTableStyledTbody = _styledComponents["default"].tbody.withConfig({
  displayName: "HBNewTableNoResults__NewTableStyledTbody",
  componentId: "sc-1mzca34-0"
})([""]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableNoResults__Container",
  componentId: "sc-1mzca34-1"
})(["", ";padding:32px 0;margin-top:12px;align-items:center;gap:12px;border:1px solid ", ";border-radius:4px;"], _mixins.flexColumn, _colors["default"].neutral300);
//# sourceMappingURL=HBNewTableNoResults.js.map